import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=7cb3f3be&"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ForgotPasswordPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports